import { useMutation, useQueryClient } from "@tanstack/react-query";

import { setFootprintingDairyManureStorage, setFootprintingDairyManureStorageAdmin } from "services";

import { footprintingDairyPrimaryQueryKeys, getEnvironment, invalidateAndRefecthQueries } from "utils";

import { FOOTPRINTING_DAIRY_MANURE_STORAGE } from "consts";

import { FootprintingDairyManureStoragePayload } from "models";

export const useMutateFootprintingDairyManureStorage = (
  farmId: string,
  year: number,
  payload: FootprintingDairyManureStoragePayload,
  primaryDataId?: string
) => {
  const isAdmin = getEnvironment().admin;
  const queryClient = useQueryClient();
  return useMutation(
    {
      mutationKey: [FOOTPRINTING_DAIRY_MANURE_STORAGE, primaryDataId, isAdmin],
      mutationFn: () => (isAdmin ? setFootprintingDairyManureStorageAdmin(payload, primaryDataId) : setFootprintingDairyManureStorage(payload, primaryDataId)),
      onSuccess: async () => {
        invalidateAndRefecthQueries(queryClient, [
          [FOOTPRINTING_DAIRY_MANURE_STORAGE, primaryDataId, isAdmin],
          ...footprintingDairyPrimaryQueryKeys(primaryDataId ?? "", farmId, year, isAdmin),
        ]);
      },
    },
    queryClient
  );
};
